import React, { memo } from 'react';
import MoreInsightsGraph from '../../../Components/moreInsightsGraph';

import FullCard, { ContentWrapper } from '../../../Components/fullCard';
import CardHeader from '../../../Components/cardHeader';
import CardInfoHeader from '../../../Components/cardInfoHeader';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

function clean(obj) {
  for (var propName in obj) {
    if (!obj[propName]?.length || obj[propName]) {
      delete obj[propName];
    }
  }
  return obj;
}

const MoreInsightsCard = ({ setSortByMoreInsights, sortByMoreInsights }) => {
  const { t } = useTranslation();
  let data = useSelector((store) => store.analytics?.text?.data?.more_insights) || {};
  const count = useSelector((store) => store.analytics?.text?.data?.more_insights_counts);
  const onSelect = (filters) => {
    setSortByMoreInsights(filters.filter_type);
  };

  const responseMapping = {
    age: 'employees within the age range of',
    gender: '',
  };

  return (
    <FullCard>
      <CardHeader
        name={t("demographicInsights")}
        customWidth="400px"
        options={{ showGender: true }}
        onSelect={onSelect}
        toolTipText={t("insightsCardTooltip")}
      />
      <ContentWrapper>
        <CardInfoHeader
          data={Object.keys(data || []).map((key) => key)}
          count={count || {}}
          responses={data ? data : null}
          responseMessage={responseMapping[sortByMoreInsights]}
        />
        <MoreInsightsGraph
          data={data ? Object.fromEntries(Object.entries(data).filter(([_, v]) => Object.keys(v)?.length)) : null}
        />
      </ContentWrapper>
    </FullCard>
  );
};

export default memo(MoreInsightsCard);
